export default __webpack_public_path__ + "static/media/Instagram-icon.0ff3a8db.svg";